
const KEY_DIALOG_POSITION = 'geolinq.dialog.position';

const getStorage = () => {
	const value = sessionStorage.getItem(KEY_DIALOG_POSITION);
	
	if( value ) {
		return JSON.parse(value);
	} else {
		return {};
	}
}

const updateStorage = (value) => {
	sessionStorage.setItem(KEY_DIALOG_POSITION, JSON.stringify(value));
}

const loadValue = (identifier) => {
	const value = getStorage();	
	return value[identifier];
}

const storeValue = (identifier, value) => {
	const storage = getStorage();
	storage[identifier] = value;
	updateStorage(storage);	
}

class DialogPosition {
	
	constructor(identifier) {
		this.identifier = identifier;
		this.storage = loadValue(identifier) || {};
	}
		
	update(dialog, position) {
		this.storage[dialog] = position;
		
		clearTimeout(this.delayWrite);
		this.delayWrite = setTimeout(() => this.storeValues(), 1000);
	}
	
	getPosition(dialog) {
		return this.storage[dialog];
	}
	
	storeValues() {
		storeValue(this.identifier, this.storage);
	}	
}

export { DialogPosition };

